"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_fsa_1 = __importDefault(require("typescript-fsa"));

var actionCreator = typescript_fsa_1.default();
/*=====================================
    ACTIONS
======================================*/

exports.default = {
  /* Scenario
  =====================================*/
  initScenarioState: actionCreator('INIT_SCENARIO_STATE'),
  setCurrentNodeId: actionCreator('SET_CURRENT_NODE_ID'),
  setPreviewAction: actionCreator('SET_PREVIEW_ACTION'),

  /* ScenarioNode
  =====================================*/
  setNodeMap: actionCreator('SET_NODE_MAP'),
  createNode: actionCreator('CREATE_NODE'),
  setActionUrl: actionCreator('SET_ACTION_URL'),
  removeActionUrl: actionCreator('REMOVE_ACTION_URL'),
  addTextOption: actionCreator('ADD_TEST_OPTION'),
  addImageOption: actionCreator('ADD_IMAGE_OPTION'),
  addImageExplanationOption: actionCreator('ADD_IMAGE_EXPLANATION_OPTION'),
  updateHeader: actionCreator('UPDATE_HEADER'),
  updateLabel: actionCreator('UPDATE_LABEL'),
  updateImageName: actionCreator('UPDATE_IMAGE_NAME'),
  updateImageUrl: actionCreator('UPDATE_IMAGE_URL'),
  updateExplanation: actionCreator('UPDATE_EXPLANATION'),
  moveNode: actionCreator('MOVE_NODE'),
  removeNode: actionCreator('REMOVE_NODE'),
  removeCurrentNode: actionCreator('REMOVE_CURRENT_NODE'),
  removeOption: actionCreator('REMOVE_OPTION'),
  moveOption: actionCreator('MOVE_OPTION'),
  insertTempalte: actionCreator('INSERT_TEMPLATE'),

  /* Keyword
  =====================================*/
  addKeyword: actionCreator('ADD_KEYWORD'),
  removeKeyword: actionCreator('REMOVE_KEYWORD'),

  /* Variable
  =====================================*/
  setVariables: actionCreator('SET_SCENARIO_VARIABLES'),

  /* Design
  =====================================*/
  setScenarioDesign: actionCreator('SET_SCENARIO_DESIGN')
};